import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth.reducer";
import loadSlice from "./load.reducer";
import loadBanner from "./banner.reducer";

const reducer = {
  auth: authSlice,
  loadData: loadSlice,
  loadBanner: loadBanner,
};

export const store = configureStore({
  reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
